{
    "exportData" : "Export Data",
    "exportDataTitle" : "Exporting...",
    "exportDataBodyText" : "Please be patient while your export is being built",
    "publish": "Publish",
    "exportDataWarning1" : "Experian protected attributes are encrypted by default when they are exported. Checking 'publish' below will export that attribute or filter in plain text. Any non Experian Protected attributes and filters will always be exported as plain text.",
    "noExportDataOverlayText":"There are no Experian protected attributes or filters to publish in this system. All other attributes and filters will be published in plain text"
}